import { Grid } from '@material-ui/core';
import React from 'react';
import StudentLessonChart from './StudentLessonChart';
import StudentDetailsCard from './StudentDetailsCard';
import { PrmStudentCurriculumLessonReportResult } from 'types/schema-generated-types';

type Props = {
  studentLessonReport: PrmStudentCurriculumLessonReportResult;
};

const OverallStudentCards: React.FC<Props> = ({ studentLessonReport }) => {
  return (
    <Grid container xs={12} spacing={2} style={{ maxWidth: 'unset' }}>
      <Grid item xs={4}>
        <StudentDetailsCard studentLessonReport={studentLessonReport!} />
      </Grid>
      <Grid item xs={8}>
        <StudentLessonChart studentLessonReport={studentLessonReport!} />
      </Grid>
    </Grid>
  );
};

export default OverallStudentCards;
